import { useSelector } from 'react-redux';
import classNames from 'classnames';
import ScrollArrows from 'components/ScrollArrows';
import ShopCard from 'components/ShopCard';
import styles from './ProductFeedList.module.scss';

function ProductFeedList({
  backInStockText,
  badgeImages,
  closeoutText,
  defaultCategoryImages,
  featuredProductText,
  groupedDiscountsContent,
  idPrefix,
  newProductText,
  packagedDateTooltipInfo,
  placeholder,
  packagedDateConfiguration,
  priceDropText,
  products,
  showDetailedFeedCard,
  terpeneTooltipInfo,
}) {
  const { lineItems } = useSelector(({ cart }) => cart);
  const storeSelection = useSelector((state) => state.storeSelection);
  const containerId = `${idPrefix}_container`;
  const leftButtonId = `${idPrefix}_left_button`;
  const rightButtonId = `${idPrefix}_right_button`;
  return (
    <section className={classNames('mx-auto', styles.feed_wrapper)}>
      <ScrollArrows
        containerId={containerId}
        leftButtonId={leftButtonId}
        rightButtonId={rightButtonId}
        scrollBuffer={30}
        scrollIncrement={400}
      >
        <ul
          id={containerId}
          className={classNames('list-unstyled m-5', styles.feed_container)}
        >
          {products.map((product) => {
            const {
              availableDiscounts,
              batchSKU,
              brand,
              category,
              classification,
              collection,
              discountedPrice,
              displayVariation,
              effect,
              images = [],
              inventoryStatus,
              mgTHC,
              mgCBD,
              packagedDate,
              percentTHC,
              percentCBD,
              name,
              price,
              SKU,
              tags,
              totalTerpenes,
              totalTerpenesUnit,
              variation,
              url,
            } = product;
            const otherCategoryDefaultUrl = defaultCategoryImages.find(
              ({ title }) => title === 'Other'
            )?.image?.url;

            const defaultImage =
              defaultCategoryImages.find(
                ({ title }) => title.toLowerCase() === category
              )?.image?.url || otherCategoryDefaultUrl;

            const lineItem = lineItems.find(
              (item) => item.batchSKU.split('~')[0] === batchSKU
            );
            return (
              <div key={`${name}${SKU}${batchSKU}-container`} className="h-100">
                {showDetailedFeedCard ? (
                  <ShopCard
                    key={`${name}${SKU}${batchSKU}${displayVariation}`}
                    isFavorite
                    availableDiscounts={availableDiscounts}
                    availableQuantity={lineItem?.availableQuantity ?? 0}
                    backInStockText={backInStockText}
                    badgeImages={badgeImages}
                    batchSKU={batchSKU}
                    brand={brand}
                    cartQuantity={lineItem?.quantity ?? 0}
                    category={category}
                    closeoutText={closeoutText}
                    customCss="h-100"
                    currencyCode={price?.currencyCode}
                    discountedCents={discountedPrice?.centAmount}
                    displayTitle={name}
                    displayVariation={displayVariation}
                    effect={collection || effect}
                    errorFallbackImage={defaultImage}
                    groupedDiscountsContent={groupedDiscountsContent}
                    inventoryStatus={inventoryStatus}
                    featuredProductText={featuredProductText}
                    mgCBD={mgCBD}
                    mgTHC={mgTHC}
                    newProductText={newProductText}
                    outOfStock={
                      !(discountedPrice?.centAmount || price?.centAmount)
                    }
                    packagedDate={packagedDate}
                    packagedDateConfiguration={packagedDateConfiguration}
                    packagedDateTooltipInfo={packagedDateTooltipInfo}
                    packageSize={
                      variation &&
                      (variation.toLowerCase().includes('pack') ||
                        /\dx\d/i.test(variation))
                        ? Number.parseFloat(variation)
                        : variation
                    }
                    percentCBD={Math.round(1000 * percentCBD) / 1000}
                    percentTHC={Math.round(1000 * percentTHC) / 1000}
                    placeholder={placeholder}
                    priceCents={price?.centAmount}
                    priceDropText={priceDropText}
                    primaryImageUrl={images?.[0]?.url ?? defaultImage}
                    productCode={SKU}
                    SKU={SKU}
                    storeSelection={storeSelection}
                    strain={classification}
                    tags={tags}
                    terpeneTooltipInfo={terpeneTooltipInfo}
                    totalTerpenes={totalTerpenes}
                    totalTerpenesUnit={totalTerpenesUnit}
                    url={url}
                    weight={variation ? Number.parseFloat(variation) : null}
                    weightUOM={
                      variation ? variation.replace(/[^A-Za-z]/g, '') : null
                    }
                    variation={variation}
                  />
                ) : (
                  <ShopCard
                    key={`${name}${SKU}${batchSKU}`}
                    isAbbreviatedCard
                    availableQuantity={lineItem?.availableQuantity ?? 0}
                    batchSKU={batchSKU}
                    brand={brand}
                    cartQuantity={lineItem?.quantity ?? 0}
                    category={category}
                    customCss="h-100"
                    currencyCode={price?.currencyCode}
                    discountedCents={discountedPrice?.centAmount}
                    displayTitle={name}
                    errorFallbackImage={defaultImage}
                    placeholder=""
                    priceCents={price?.centAmount}
                    primaryImageUrl={images?.[0]?.url ?? defaultImage}
                    productCode={SKU}
                    SKU={SKU}
                    storeSelection={storeSelection}
                    url={url}
                    variation={variation}
                  />
                )}
              </div>
            );
          })}
        </ul>
      </ScrollArrows>
    </section>
  );
}

export default ProductFeedList;
